import React, { useState } from "react";
import { api, errMsg, money } from "@/lib/api";
import { Field, inputCls } from "@/components/common";
import { STATUS_LABEL } from "@/pages/Account";
import { ReturnForm } from "@/components/CareForms";

const FLOW = ["confirmed", "in_production", "shipped", "delivered"];

export function TrackBox({ initialOrder = "", compact = false }: { initialOrder?: string; compact?: boolean }) {
  const [f, setF] = useState({ order_number: initialOrder, email: "" });
  const [o, setO] = useState<any>(null);
  const [err, setErr] = useState("");
  const [ret, setRet] = useState(false);
  const submit = async (e: React.FormEvent) => {
    e.preventDefault(); setErr(""); setO(null); setRet(false);
    try { setO((await api.post("/orders/track", f)).data); } catch (x) { setErr(errMsg(x)); }
  };
  const idx = o ? FLOW.indexOf(o.status) : -1;
  return (
    <div className={compact ? "space-y-6" : "grid md:grid-cols-[380px_1fr] gap-12"}>
      <form onSubmit={submit} className={compact ? "grid sm:grid-cols-[1fr_1fr_auto] gap-4 items-end" : "space-y-6"} data-testid="track-form">
        <Field label="Order number"><input required value={f.order_number} onChange={(e) => setF({ ...f, order_number: e.target.value })} placeholder="SC-123456" className={inputCls} data-testid="track-order-input" /></Field>
        <Field label="Email"><input required type="email" value={f.email} onChange={(e) => setF({ ...f, email: e.target.value })} className={inputCls} data-testid="track-email-input" /></Field>
        <button className={`btn-ink py-4 px-8 text-xs tracking-[0.25em] uppercase ${compact ? "" : "w-full"}`} data-testid="track-submit-button">Track</button>
      </form>
      {err && <p className="text-sm text-red-800" data-testid="track-error">{err}</p>}
      {o && (
        <div className={`border border-neutral-200 bg-white ${compact ? "p-5 md:p-8" : "p-8"}`} data-testid="track-result">
          <p className="font-display text-3xl">Order {o.number}</p>
          <p className="eyebrow text-[var(--c-primary)] mt-2" data-testid="track-status">{STATUS_LABEL[o.status]}</p>
          <ol className="grid grid-cols-4 gap-2 mt-8">
            {FLOW.map((s, i) => (
              <li key={s} className="text-center"><div className={`h-1 mb-3 ${i <= idx ? "bg-[var(--c-primary)]" : "bg-neutral-200"}`} /><span className={`text-[11px] ${i <= idx ? "" : "text-neutral-400"}`}>{STATUS_LABEL[s]}</span></li>
            ))}
          </ol>
          {o.tracking?.number && <p className="text-sm mt-6">Carrier: {o.tracking.carrier} · {o.tracking.url ? <a href={o.tracking.url} target="_blank" rel="noreferrer" className="underline" data-testid="track-number">{o.tracking.number}</a> : <span data-testid="track-number">{o.tracking.number}</span>}</p>}
          <ul className="mt-8 space-y-3 text-sm border-t border-neutral-200 pt-6">
            {[...(o.timeline || [])].reverse().map((t: any, i: number) => (
              <li key={i} className="flex justify-between gap-4"><span>{STATUS_LABEL[t.status]}{t.note ? ` — ${t.note}` : ""}</span><span className="text-neutral-500 text-xs">{new Date(t.at).toLocaleString("en-AU")}</span></li>
            ))}
          </ul>
          <div className="flex flex-wrap items-center justify-between gap-4 mt-6">
            <p className="text-sm">Total {money(o.total)}</p>
            {o.payment_status === "paid" && !ret && <button onClick={() => setRet(true)} className="btn-line px-6 py-3 text-[11px] tracking-[0.2em] uppercase" data-testid="track-start-return">Start a Return</button>}
          </div>
          {ret && <div className="mt-6"><ReturnForm embedded orderNumber={o.number} email={f.email} items={(o.items || []).map((i: any) => i.name || i.title).filter(Boolean)} /></div>}
        </div>
      )}
    </div>
  );
}

export const OrderLookupBlock = ({ b }: any) => (
  <section id="track-my-order" className="max-w-4xl mx-auto px-5 md:px-12 py-10 scroll-mt-48" data-testid="order-lookup-block">
    <div className="border border-neutral-200 bg-[var(--c-muted)] p-6 md:p-10">
      <h2 className="font-display uppercase tracking-[0.08em] text-2xl md:text-3xl">{b.heading || "Track My Order"}</h2>
      {b.text && <p className="text-neutral-600 mt-2 mb-6">{b.text}</p>}
      <TrackBox compact />
    </div>
  </section>
);
